module.exports = __webpack_public_path__ + "img/con4_inp.94ec0bce.jpg";